import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CreateExpenseRequest, Expense, UpdateExpenseRequest } from '../types';
import { apiClient } from '../services/api';

type SaveExpenseInput = {
  id?: string;
  data: CreateExpenseRequest | UpdateExpenseRequest;
};

export const useExpenseMutations = () => {
  const queryClient = useQueryClient();
  const invalidateExpenses = () => Promise.all([
    queryClient.invalidateQueries({ queryKey: ['expenses'] }),
    queryClient.invalidateQueries({ queryKey: ['dashboard'] }),
    queryClient.invalidateQueries({ queryKey: ['admin'] }),
  ]);

  const saveExpenseMutation = useMutation<Expense, unknown, SaveExpenseInput>({
    mutationFn: ({ id, data }) => id
      ? apiClient.updateExpense(id, data as UpdateExpenseRequest)
      : apiClient.createExpense(data as CreateExpenseRequest),
    onSuccess: invalidateExpenses,
  });

  const deleteExpenseMutation = useMutation<void, unknown, string>({
    mutationFn: id => apiClient.deleteExpense(id),
    onSuccess: invalidateExpenses,
  });

  return { saveExpenseMutation, deleteExpenseMutation };
};
